import type { ProductSummaryDTO } from './api';

/** Package completeness and workflow completion are separate facts. */
export function productPreprocessState(product: Pick<ProductSummaryDTO, 'sourcePlatform' | 'status' | 'preprocessStatus' | 'preprocessJobId' | 'integrityStatus' | 'preprocessCompleted'>): { status: string; label?: string } {
  if (product.status === 'deleted') return { status: 'deleted' };
  if (product.sourcePlatform !== 'wildberries') return { status: product.preprocessStatus };
  // A current task always takes precedence over a package left by an earlier run.
  if ((product.preprocessJobId && product.preprocessStatus !== 'completed') || product.status !== 'ready' || !['completed', 'queued'].includes(product.preprocessStatus)) {
    return { status: product.preprocessStatus };
  }
  if (product.integrityStatus === 'valid') return { status: 'valid', label: '可发布' };
  if (product.preprocessCompleted) return { status: 'draft', label: '预处理完成·待完善' };
  return { status: 'draft', label: '已采集·待预处理' };
}
